
import React, { useEffect } from 'react'
import Form from '../components/widgets/form'
const Home = (props) => {

    const urlParams = new URLSearchParams(window.location.search);
    const branch = urlParams.get("b");
    const support = urlParams.get("s");

    if (branch && support) {
      sessionStorage.setItem("branch", branch);
      sessionStorage.setItem("support", support);
    }
    
    useEffect(() => {
        if (document.getElementById("loader").style.display !== "none") {
            setTimeout(() => {
                document.getElementById("loader").style.display = "none"
            }, 2000);
        }
    }, [])
    return (
        <>

            <div className="container-fluid bg">
                <div className="loader-container" id="loader">
                    <div className="holder">
                        <div className="la-line-scale la-2x">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>


                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="text_box">
                                Görüntülü Görüşme ile
                                <strong>Hemen Hesap Aç!</strong>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="form_box">
                                <Form {...props} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid work_box">
                <div className="container">
                    <div className="row" style={{ marginBottom: 10 }}>
                        <div className="col-sm-4 col-md-4">
                            <h3 style={{ fontWeight: "600", color: "#fff", textAlign: "left", marginBottom: "1.5rem" }}>1. ADIM</h3>
                            <div>
                                <span style={{ marginBottom: "1.5rem" }}>
                                    <img src="images/giris.svg" alt="" />
                                    <strong>Giriş Yapınız</strong>
                                </span>
                                <p>Uygunluk anketimizi doldurarak, kendinize uygun ürün ve hizmetleri seçebilirsiniz.</p>
                            </div>
                        </div>

                        <div className="col-sm-4 col-md-4">
                            <h3 style={{ fontWeight: "600", color: "#fff", textAlign: "left", marginBottom: "1.5rem" }}>2. ADIM</h3>
                            <div>
                                <span style={{ marginBottom: "1.5rem" }}>
                                    <img src="/images/sozlesme.svg" alt="" />
                                    <strong>Görüntülü Görüşme</strong>
                                </span>
                                <p>Görüntülü Görüşme ile uygulama adımına geçebilirsiniz.
                                </p>
                            </div>
                        </div>

                        <div className="col-sm-4 col-md-4">
                            <h3 style={{ fontWeight: "600", color: "#fff", textAlign: "left", marginBottom: "1.5rem" }}>3. ADIM</h3>
                            <div>
                                <span style={{ marginBottom: "1.5rem" }}>
                                    <img src="/images/onay.svg" alt="" />
                                    <strong>Hesabınızı Kullanmaya Başlayın</strong>
                                </span>
                                <p>Görüntülü görüşmeyi tamamladıktan sonra  telefonunuza gelen giriş bilgileri ile hesabınızı hemen kullanmaya başlayabilirsiniz.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>

    )

}
export default Home
